class HubspotFormLoader {

    wrapperId;
    portalId;
    formId;

    constructor(formWrapper) {
        this.wrapperId = formWrapper.id;
        this.portalId = formWrapper.dataset["portalId"];
        this.formId = formWrapper.dataset["formId"];
        this.loadForm()
    }

    loadForm() {
        // cssRequired because of hs-datepicker
        try {
            hbspt.forms.create({
                region: "eu1",
                target: "#"+this.wrapperId,
                portalId: this.portalId,
                formId: this.formId,
                css: "",
                cssClass: "hubspot-form__form",
                cssRequired: true
        });
        } catch (e) {
            if (console) {
                console.error(e)
            }
        }
    }

}

export default class HubspotFormsInit {

    constructor() {
        if (!document.body.classList.contains('neos-backend')) {
            this.addEventForCookieConsentInitialization()
            this.addEventForCookieConsentChange()
        } else {
            this.addHubSpotForms()
        }
    }

    addHubSpotForms = () => {
        let hubspotForms = document.querySelectorAll('.js-hubspot-form')
        hubspotForms.forEach((formWrapperElement) => {
            // If the HubSpot script is not yet loaded
            if (typeof hbspt === 'undefined') {
                // Wait until the script from hubspot is fully loaded, then initialize the form after load event
                document.querySelector('#hubspot-form-script').addEventListener('load', () => {
                    new HubspotFormLoader(formWrapperElement);
                })
            } else {
                // hbspt is already present so init now
                new HubspotFormLoader(formWrapperElement);
            }
        })
    }

    addEventForCookieConsentInitialization = () => {
        window.addEventListener('UC_UI_INITIALIZED',  () => {
            this.addHubSpotForms()
        })
    }

    addEventForCookieConsentChange = () => {
        // if a change (save) is given try to init formLoader again to show form after cookie change
        window.addEventListener("UC_UI_CMP_EVENT", (e) => {
            if (e.detail.type === "SAVE") this.addHubSpotForms()
        })
    }

}
